import React from 'react';
import Button from 'react-bootstrap/Button';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

function PreviewReportButton() {

  const tooltip = (
    <Tooltip>Preview PDF</Tooltip>
  )

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <Button className="reportActionButton">
        <FontAwesomeIcon icon={solid("file-Pdf")} className="buttonIcon" />
      </Button>
    </OverlayTrigger>
  );
}

export default PreviewReportButton;